/* eslint-disable sort-keys */
import { graphql } from 'gatsby'
import React from 'react'

import { Seo } from '../components'
import Layout from '../layouts/Layout'
import { SliceRenderer } from '../utils/SliceRenderer'

const BlogPostPage = ({ data, pageContext }) => {
  if (!data) return null
  const {
    wpPost: {
      blogcontent,
      blogtipssection,
      herocontent,
      quotecontent,
      related,
    },
  } = data
  const contentMap = {
    Hero: { fieldGroupName: 'herocontent', ...herocontent },
    Quote: { fieldGroupName: 'quotecontent', ...quotecontent },
    Blogcontent: { fieldGroupName: 'blogcontent', ...blogcontent },
    BlogTips: { fieldGroupName: 'blogtipssection', ...blogtipssection },
    RelatedArticles: { fieldGroupName: 'bloglistingsection', ...related },
  }

  const { components, lang, taxonomy } = pageContext

  const slices = components?.map((component) => contentMap[component]) || []

  return (
    <Layout pageContext={pageContext}>
      <SliceRenderer
        lang={lang.slice(0, 2)}
        pageType={taxonomy}
        slices={slices.filter((item) => item !== undefined)}
      />
    </Layout>
  )
}

export default BlogPostPage

export const Head = ({ data, location, pageContext }) => {
  const { lang } = pageContext
  const {
    wpPost: { date, herocontent, seo, title },
  } = data
  const image =
    herocontent?.heroimage?.localFile?.childImageSharp?.gatsbyImageData
  return (
    <Seo
      canonical={location.pathname}
      date={date}
      description={seo.metaDesc}
      image={image}
      lang={lang.slice(0, 2)}
      metaTitle={seo.title}
      pageType="blogpost"
      title={title}
    />
  )
}

export const query = graphql`
  query BlogPageQuery($id: String!, $lang: String!) {
    wpPost(id: { eq: $id }, language: { locale: { eq: $lang } }) {
      id
      language {
        code
        locale
        name
        slug
      }
      slug
      title
      date
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
      quotecontent {
        quotecontainerwidth
        quoteheading
        quotekicker
        quotecontent
        quotebackground {
          node {
            altText
            sourceUrl
            localFile {
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                  webpOptions: { quality: 80 }
                  avifOptions: { lossless: true, quality: 80 }
                )
              }
            }
            mediaItemUrl
            mediaType
          }
        }
      }
      herocontent {
        herocontainerwidth
        herocontentheading
        heroseparatorusp2
        heroseparatorusp
        herodiscovermorelabel
        herocta2
        herocta1
        herocontenttext
        herocontentkicker
        herocontentimage {
          node {
            altText
            sourceUrl
            localFile {
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                  webpOptions: { quality: 80 }
                  avifOptions: { lossless: true, quality: 80 }
                )
              }
            }
            mediaItemUrl
            mediaType
          }
        }
        herocontentmobileimage {
          node {
            altText
            sourceUrl
            localFile {
              childImageSharp {
                gatsbyImageData(
                  quality: 80
                  webpOptions: { quality: 80 }
                  avifOptions: { lossless: true, quality: 80 }
                )
              }
            }
            mediaItemUrl
            mediaType
          }
        }
      }
      related {
        relatedpages {
          nodes {
            id
            slug
            uri
            ... on WpPage {
              id
              title
              pageType {
                uri
                taxonomy
              }
              seoData {
                metadescription
                pagetitle
              }
              seo {
                title
                metaDesc
              }
              date
              herocontent {
                herocontentimage {
                  node {
                    id
                    altText
                    mediaType
                    mediaItemUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                  }
                }
              }
            }
            ... on WpPost {
              id
              title
              seoData {
                metadescription
                pagetitle
              }
              seo {
                title
                metaDesc
              }
              date
              herocontent {
                herocontentimage {
                  node {
                    id
                    altText
                    mediaType
                    mediaItemUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 80
                          webpOptions: { quality: 80 }
                          avifOptions: { lossless: true, quality: 80 }
                        )
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      blogcontent {
        content
        heading
      }
      blogtipssection {
        blogtipsheading
        blogtipcontentcard01 {
          contentcardcontent
          contentcardtitle
        }
        blogtipcontentcard02 {
          contentcardcontent
          contentcardtitle
        }
        blogtipcontentcard03 {
          contentcardcontent
          contentcardtitle
        }
        blogtipcontentcard04 {
          contentcardcontent
          contentcardtitle
        }
        blogtipcontentcard05 {
          contentcardcontent
          contentcardtitle
        }
        blogtipcontentcard06 {
          contentcardcontent
          contentcardtitle
        }
      }
    }
  }
`
